{
    "TelephonenosLabel": "Numero di telefono:",
    "AcdagentsLabel": "Agente\/i ACD:",
    "LocationLabel": "Posizione da\/per:",
    "LocationOptionAny": "[Qualsiasi chiamata da\/per queste località]",
    "LocationOptionFrom": "Solo chiamate da queste località",
    "LocationOptionTo": "Solo chiamate verso queste località",
    "LocationalFiltering_SectionHeader": "Filtraggio locale",
    "LocationalFiltering_AnyPlaceholder": "[Qualsiasi]",
    "LocationalFiltering_DevicesLabel": "Dispositivo\/i:",
    "NAME": "LocationalFiltering",
    "TelephonenosLabelDNIS": "N. di tel. \/ n. di DNIS:",
    "TelephonenoDescriptionsLabel": "Telefono n. Descrizione\/i:",
    "AcdagentsLabel_MST": "Agenti:"
}